import { hash } from '@ember/helper';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import { and, not } from 'ember-truth-helpers';

import AssetPreview from 'umg-ember-backend/components/ui/asset-preview';
import { getRecordType } from 'umg-ember-backend/utils/get-record-type';
import { labelValueOptions } from 'umg-ember-backend/utils/intl';

export default class PageBuilderOptionsBackground extends Component {
  // Services
  @service intl;

  // Defaults
  backgroundAlignments = ['top', 'middle', 'bottom'];

  // Getter and setter
  get isContentItem() {
    return getRecordType(this.args.form.model) === 'content-item';
  }

  get isSpacer() {
    return this.args.form.model.type === 'spacer';
  }

  get backgroundPositions() {
    if (this.args.mlp.isV2) {
      return [
        { value: 'fixed', label: 'fixed' },
        { value: 'parallax', label: 'parallax' },
      ];
    }

    return [
      { value: 'fixed', label: 'fixed' },
      { value: 'parallax', label: 'parallax' },
      { value: 'repeat', label: 'repeat' },
      { value: 'cover', label: 'cover' },
    ];
  }

  // Getter and setter
  get backgroundAlignmentOptions() {
    return labelValueOptions.call(this, this.backgroundAlignments, [
      'forms.content-item.options.backgroundAlignment',
    ]);
  }

  // Template
  <template>
    <@form.fieldset
      @titleKey='background'
      @isClosed={{true}}
      @showSelectedAttributesIndicator={{true}}
      as |fieldset|
    >
      <fieldset.field
        @property='options.backgroundColor'
        @type='color'
        @colorFormat='rgba'
      />

      {{#unless (and this.isSpacer (not @mlp.isV2))}}
        <fieldset.field
          @property='options.backgroundPosition'
          @type='select-value'
          @options={{this.backgroundPositions}}
        />
      {{/unless}}

      <fieldset.field
        @filters={{hash assetFolderId='106'}}
        @property='backgroundImage'
        @options={{hash allowedFolder='100'}}
        @type='belongs-to'
        as |record|
      >
        <AssetPreview @asset={{record}} />
      </fieldset.field>

      {{#if @form.model.backgroundImage}}
        <fieldset.field
          @filters={{hash assetFolderId='11'}}
          @property='backgroundVideo'
          @options={{hash allowedFolder='101'}}
          @type='belongs-to'
          as |record|
        >
          <AssetPreview @asset={{record}} />
        </fieldset.field>

        {{#if this.isContentItem}}
          <fieldset.field
            @filters={{hash assetFolderId='106'}}
            @property='backgroundImageMobile'
            @on={{hash openRecord=@openRecord openNewRecord=@openNewRecord}}
            @options={{hash allowedFolder='100'}}
            @type='belongs-to'
            as |record|
          >
            <AssetPreview @asset={{record}} />
          </fieldset.field>

          {{#if @form.model.backgroundImageMobile}}
            <fieldset.field
              @filters={{hash assetFolderId='11'}}
              @property='backgroundVideoMobile'
              @on={{hash openRecord=@openRecord openNewRecord=@openNewRecord}}
              @options={{hash allowedFolder='101'}}
              @type='belongs-to'
              as |record|
            >
              <AssetPreview @asset={{record}} />
            </fieldset.field>
          {{/if}}
        {{/if}}
      {{/if}}

      {{#if (and this.isSpacer (not @mlp.isV2))}}
        <fieldset.field
          @property='options.backgroundAlignment'
          @type='select-value'
          @options={{this.backgroundAlignmentOptions}}
        />
      {{/if}}
    </@form.fieldset>
  </template>
}
